<template>
  <div class="login-container">
    <div class="login-box">
      <h2>RaiseTrack Login</h2>

      <form @submit.prevent="login">
        <div class="form-group">
          <label>Email</label>
          <input v-model="formData.email" type="email" placeholder="Enter your email" required />
        </div>

        <div class="form-group">
          <label>Password</label>
          <input v-model="formData.password" type="password" placeholder="Enter your password" required />
        </div>

        <button type="submit" :disabled="loading">
          {{ loading ? "Logging in..." : "Login" }}
        </button>
      </form>

      <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "LoginPage",
  data() {
    return {
      formData: {
        email: "",
        password: "",
      },
      errorMessage: "",
      loading: false,
    };
  },
  methods: {
    async login() {
      this.errorMessage = "";
      this.loading = true;

      try {
        const res = await axios.post(
          "https://api.roberms.com/fundraise/login/",
          this.formData
        );

        if (res.data && res.data.token) {
          // Save token and user
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("user", JSON.stringify(res.data.user));

          // Redirect to dashboard
          window.location.href = "/dashboard"; // Use full reload to avoid router issues
        } else {
          this.errorMessage = res.data.message || "Invalid email or password";
        }
      } catch (err) {
        console.error(err);
        this.errorMessage =
          (err.response && err.response.data && err.response.data.message) ||
          "Login failed. Please try again.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #f5f5f5;
}
.login-box {
  background: #fff;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  width: 350px;
}
h2 {
  text-align: center;
  margin-bottom: 1.5rem;
}
.form-group {
  margin-bottom: 1rem;
}
input {
  width: 100%;
  padding: 0.6rem;
  border-radius: 5px;
  border: 1px solid #ccc;
}
button {
  width: 100%;
  padding: 0.7rem;
  background: #007bff;
  border: none;
  color: #fff;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
}
button:disabled {
  background: #999;
  cursor: not-allowed;
}
.error {
  color: red;
  text-align: center;
  margin-top: 1rem;
}
</style>
